(function () {
  function initMoreLikeThisSplide() {
    if (typeof Splide === 'undefined') {
      setTimeout(initMoreLikeThisSplide, 300);
      return;
    }

    document.querySelectorAll('.featured-collection-silverts__slider.splide').forEach(function (slider) {
      if (slider.dataset.splideMounted === 'true') return;

      var desktop = Number(slider.dataset.productsPerRowDesktop) || 4;
      var tablet = Number(slider.dataset.productsPerRowTablet) || 3;
      var mobile = Number(slider.dataset.productsPerRowMobile) || 2;
      var gap = Number(slider.dataset.columnSpacing) || 20;

      slider.dataset.splideMounted = 'true';

      new Splide(slider, {
        type: 'slide',
        perPage: desktop,
        perMove: 1,
        gap: gap + 'px',
        arrows: true,
        pagination: false,
        autoplay: false,
        keyboard: true,
        slideFocus: false,
        rewind: false,
        breakpoints: {
          989: { perPage: tablet },
          749: { perPage: mobile }
        }
      }).mount();
    });
  }

  document.addEventListener('DOMContentLoaded', initMoreLikeThisSplide);
  window.addEventListener('load', initMoreLikeThisSplide);
  document.addEventListener('shopify:section:load', initMoreLikeThisSplide);

  new MutationObserver(function () {
    initMoreLikeThisSplide();
  }).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();